const columns = (teams, templates) => [
  {
    name: 'Name',
    selector: (row) => row.attributes.full_name,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Work Email',
    selector: (row) => row.attributes.email,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Team',
    selector: (row) => row.attributes.team,
    sortable: true,
    filter: {
      type: 'MULTI_SELECT',
      options: teams,
    },
  },
  {
    name: 'Program',
    selector: (row) => row.attributes.programs.map((program) => program.title).join(', '),
    sortable: true,
    filter: {
      type: 'MULTI_SELECT',
      options: templates,
    },
  },
  {
    name: 'Invited On',
    selector: (row) => row.attributes.invited_on_timestamp,
    format: (row) => row.attributes.invited_on_formatted,
    sortable: true,
  },
  {
    name: 'Assessment',
    selector: (row) => new Date(row.attributes.assessment.length > 0 ? row.attributes.assessment : null),
    format: (row) => row.attributes.assessment,
    sortable: true,
  },
  {
    name: 'Ext. Assessment',
    selector: (row) => row.attributes.external_assessment,
    format: (row) => row.attributes.external_assessment_formatted,
    sortable: true,
  },
  {
    name: 'Members not currently in a program',
    selector: (row) => row.attributes.programs_state.toString(),
    omit: true,
    filter: {
      type: 'SINGLE_SELECT',
      options: [
        { label: 'No programs assigned', value: 'no_assigned' },
        { label: 'Programs assigned', value: 'with_assigned' },
        { label: 'Custom Programs', value: 'custom_programs' },
      ],
    },
  },
];

export default columns;
